// Constants.js
const prod = {
    url: {
   
       REACT_APP_API_URL: 'https://molu.co/api/v1',
   
       REACT_APP_BASE_URL: 'https://molu.co',
       
       REACT_API_IMAGE_URL: '',
   
       STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_PUBLIC_KEY
   },
   funnel: {
     '001': 'Email',
     '002': 'FaceBook',
     '003': 'IG',
     '004': 'TikTok',
     '005': 'Shopify',
   },
  };

   
   
   const dev = {
    url: {
   
       REACT_APP_API_URL: 'http://127.0.0.1:8000/api/v1',
   
       REACT_APP_BASE_URL: 'http://127.0.0.1:3000',
   
       REACT_API_IMAGE_URL: 'http://127.0.0.1:8000',
   
       STRIPE_PUBLIC_KEY: process.env.REACT_APP_STRIPE_TEST_KEY
    },
    // http://127.0.0.1:3000/?CID=002-L01 says source=facebook, campaign=L01
    funnel: {
      '001': 'Email',
      '002': 'FaceBook',
      '003': 'IG',
      '004': 'TikTok',
      '005': 'Shopify',
    },
   };
   
   
   export const config = process.env.NODE_ENV === 'development' ? dev : prod;
   
   
   
